export enum FormTypes {
    TEXT = 'text',
    SELECT = 'select',
    CHECKBOX = 'checkbox',
    RADIO = 'radio',
    TEXTAREA = 'textarea',
    MULTISELECT = "multiselect",
    CALENDAR = "calendar",
}


export interface FormModel {
    id?: string;
    label: string;
    value: string;
    required?: boolean;
}


export interface SirsRolesI {
    id: string;
    label: string;
}


export interface User {
    id: string;
    firstname: string;
    lastname: string;
    email: string;
    role: string;
    activated: boolean;
    sendinitialmail: boolean;
    timestamp: number;
}


